import { useState, useEffect } from "react";
import { UnoStoreHooks, UiComponents, initialize } from "@simulanisindia/ui";
import { API_URL, applicationId } from "./env";
import { isMobile } from "./utils/common.js";
import Layout from "./components/layout/Layout";
import { getGroupChildrenList, getGroupHierarchy, getGroupTypes } from "./apiclient/apiDataFetcher";
import { useDispatch } from "react-redux";
import useWindowDimensions from "./utils/useWindowDimension.js";

const { useUnoSelector } = UnoStoreHooks;
const { FullScreenLoader } = UiComponents;

const App = () => {
  const windowDimensions = useWindowDimensions();
  const [loading, setLoading] = useState(true);
  const userData = useUnoSelector((state) => state.user);
  const configData = useUnoSelector((state) => state.config);
  const dispatch = useDispatch();
  const [isMobileView, setIsMobileView] = useState(false);

  useEffect(() => {
    setLoading(true);
    initialize(applicationId, "token", undefined, false, true, API_URL).then(() => setLoading(false));
  }, []);

  useEffect(() => {
    if (userData.token) {
      getGroupTypes(dispatch, configData?.config?.UNO_URL, userData?.token);
      getGroupHierarchy(dispatch, configData?.config?.UNO_URL, userData?.user.group.uuid);
      getGroupChildrenList(dispatch, configData?.config?.UNO_URL, userData?.user.group.uuid);
    }
  }, [userData?.user, loading, userData?.user?.group]);

  useEffect(() => {
    const isMobileView = isMobile(windowDimensions.width, windowDimensions.height);
    setIsMobileView(isMobileView);
  }, [windowDimensions.height, windowDimensions.width]);

  useEffect(() => {
    if (isMobileView) {
      document.body.classList.add("mobile-view");
    } else {
      document.body.classList.remove("mobile-view");
    }
  }, [isMobileView]);

  return <>{loading ? <FullScreenLoader loading={loading} /> : <Layout isMobileView={isMobileView} />}</>;
};

export default App;
